export const BOUTONS_SAISONNIERS = [
  {
    "titreDuBouton": "Je me renseigne sur la prime de \nNoël",
    "nomDuBouton": "La prime de Noël",
    "dateDebut": "01/12",
    "dateFin": "31/12",
    "lien": "https:///www.caf.fr/allocataires/actualites/actualites-nationales/la-prime-de-noel-arrive",
    "tagChapitre3": "actualites_prime_noel"
  },
  {
    "titreDuBouton": "Je me renseigne sur l’allocation de \nrentrée scolaire",
    "nomDuBouton": "L’allocation de rentrée scolaire",
    "dateDebut": "12/07",
    "dateFin": "31/08",
    "lien": "https://www.caf.fr/allocataires/actualites/actualites-nationales/l-allocation-de-rentree-scolaire-mode-d-emploi",
    "tagChapitre3": "actualites_ars"
  },
  {
    "titreDuBouton": "Je garde mon logement étudiant en \nété",
    "nomDuBouton": "Le maintien du logement étudiant en été",
    "dateDebut": "10/05",
    "dateFin": "11/07",
    "lien": "https://www.caf.fr/allocataires/actualites/actualites-nationales/etudiants-c-est-le-moment-de-declarer-si-vous-conservez-votre-logement-cet-ete",
    "tagChapitre3": "actualites_maintien_lieu"
  }
]
